// @ts-check
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useBlocker } from "react-router-dom";
import AppStore from "Stores/AppStore";
import { ShowAlert2 } from "Utils/CommonFunctions";
import Helper from "Utils/Helper";

/*
Заметка о blocked.
Поддержка функции была добавлена, чтобы была возможность
единомоментно "сбросить" условия блокировки и совершить переход куда-либо.

Проблема тут в том, что значение через props'ы
передаётся на стадии рендера, а не сразу при изменении
связанных свойств (реактивность же...).
Соответсвенно, если после изменения связанных свойств сразу совершить навигацию,
то в тут в пропсах будет старое значение blocked, что может, например, заблокировать переход.
Функция лишена такого недостатка, т.к. при каждом вызове всегда возвращается актуальное значение.
*/

/**
 * @typedef {object} props
 * @property {boolean | (() => boolean)} blocked
 * @property {string} title
 */

/**
 * @param {props} prevent 
 * @returns {() => Promise<boolean>}
 */
const createCheckBlockingHandle = (prevent) => () => {
    if (Helper.CallFunctionOrValue(prevent.blocked) == false)
        return Promise.resolve(true);

    return new Promise((resolve) => {
        let yesClick = () => resolve(true);
        let noClick = () => resolve(false);

        ShowAlert2({
            type: "warning",
            autoClose: false,
            text: prevent.title ? prevent.title : 'У вас есть несохраненные изменения. Если вы покинете страницу, все изменения будут утеряны.',
            buttons: [{
                title: 'Продолжить',
                callback: yesClick
            }, {
                title: 'Отменить',
                callback: noClick
            }],
            hideClosebutton: true,
            onRelease: noClick
        });
    });
}

/**
 * @param {props} prevent 
 */
const createBeforeunloadHandle = (prevent) => (/** @type {BeforeUnloadEvent} */ event) => {
    if (Helper.CallFunctionOrValue(prevent.blocked)) {
        event.preventDefault();
        event.returnValue = "";
    }
};

/**
 * @param {props} props 
 * @returns 
 */
const TransitionBlocker = (props) => {
    const blocker = useBlocker(({ currentLocation, nextLocation }) =>
        Helper.CallFunctionOrValue(props.blocked) &&
        currentLocation.pathname !== nextLocation.pathname);

    const [prevent] = useState({ ...props, alert: 0 })
    const [handlers] = useState({ check: createCheckBlockingHandle(prevent), beforeunload: createBeforeunloadHandle(prevent) });

    useEffect(() => {
        if (blocker.state === 'blocked') {
            handlers.check()
                .then((result) => {
                    if (blocker.state === 'blocked') {
                        if (result)
                            blocker.proceed();
                        else
                            blocker.reset();
                    }
                });
        }
    }, [blocker]);

    useEffect(() => {
        Object.assign(prevent, props);
    }, [props])

    useEffect(() => {
        AppStore.SetCheckTransitionAllowed(handlers.check);
        window.addEventListener("beforeunload", handlers.beforeunload);
    }, []);

    useEffect(() => () => {
        AppStore.SetCheckTransitionAllowed(null);
        window.removeEventListener("beforeunload", handlers.beforeunload);
    }, [])

    return ('');
}

export default observer(TransitionBlocker);